var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.217 10.5646L1.8896 14.1105L5.4356 2.7831L7.48271 7.35039C7.49104 7.37051 7.49985 7.39039 7.5089 7.41015L5.7939 9.12504L6.82331 10.1544L8.51998 8.45789C8.56248 8.4792 8.60569 8.49908 8.64986 8.51753L13.217 10.5646ZM0.962196 15.9604C0.391296 16.1533 -0.153303 15.6087 0.0395966 15.0378L4.672 0.494802C4.8865 -0.140198 5.7729 -0.172197 6.03268 0.445902L8.8247 6.78617C8.89851 6.96176 9.03815 7.10141 9.21376 7.17522L15.554 9.96724C16.1721 10.227 16.1402 11.1134 15.5051 11.3279L0.962196 15.9604Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0698 1.93609L11.296 5.70996L10.2666 4.68057L14.0404 0.906701L15.0698 1.93609Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9264 7.08008L15.0698 5.93652L14.0404 4.90713L12.8969 6.05069L13.9264 7.08008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSuccess);
export default __webpack_public_path__ + "static/media/map-success.70e7265ee4cf5229fea7e959903dd851.svg";
export { ForwardRef as ReactComponent };